import styled from 'styled-components';

const ReviewItemStyle = styled.div`
	--commentImageSizes: var(--sp5x);
	--commentMarginBottom: var(--sp6x);

	&:not(:last-child) {
		margin-bottom: var(--commentMarginBottom);
	}

	.comment-top {
		display: flex;
		align-items: center;

		.comment-image {
			width: var(--commentImageSizes);
			padding-top: var(--commentImageSizes);

			img {
				object-fit: contain;
			}
		}

		.full-name {
			margin: 0 var(--sp1x);
			text-transform: capitalize;
		}
	}

	.comment-rate, .editor-wrapper {
		margin-top: var(--sp2x);
	}

	.ant-rate {
		font-size: var(--h5) !important;
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--commentMarginBottom: var(--sp5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--commentMarginBottom: var(--sp5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--commentMarginBottom: var(--sp5x);
	}
`;

export default ReviewItemStyle;
